/*
 * Patents page (sections/ps-pat-*.liquid): reveal-on-scroll and the figure
 * animation registry. Every section loads this file with `defer`; only the
 * first copy runs.
 *
 * A section registers its figure before or after this file loads with:
 *   (window.PSPatQ = window.PSPatQ || []).push(['feel', function (root, ctx) {
 *     return { play: fn, pause: fn };   // both optional
 *   }]);
 * and marks the element with data-pat-fig="feel". play() runs while the
 * figure is on screen and pause() when it leaves. ctx.reduce is true when
 * the visitor prefers reduced motion: show a finished, still state then.
 */
(function () {
  if (window.PSPat) return;

  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var inits = {};
  document.documentElement.classList.add('pat-js');

  var io = 'IntersectionObserver' in window
    ? new IntersectionObserver(onSee, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 })
    : null;

  function onSee(entries) {
    entries.forEach(function (entry) {
      var el = entry.target;
      var api = el.__pat;
      if (entry.isIntersecting) {
        el.classList.add('is-in');
        if (api && api.play) api.play();
      } else if (api && api.pause) {
        api.pause();
      }
    });
  }

  function watch(el) {
    if (el.__patWatched) return;
    el.__patWatched = true;
    if (io) {
      io.observe(el);
    } else {
      el.classList.add('is-in');
      if (el.__pat && el.__pat.play) el.__pat.play();
    }
  }

  function bind(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-pat-fig]').forEach(function (el) {
      if (el.__pat) return;
      var init = inits[el.getAttribute('data-pat-fig')];
      if (!init) return;
      try {
        el.__pat = init(el, { reduce: reduce }) || {};
      } catch (e) {
        el.__pat = {};
      }
      watch(el);
    });
    root.querySelectorAll('.pat').forEach(watch);
  }

  function define(name, init) {
    inits[name] = init;
    bind(document);
  }

  var queued = Array.isArray(window.PSPatQ) ? window.PSPatQ : [];
  window.PSPat = { define: define, reduce: reduce };
  window.PSPatQ = { push: function (item) { define(item[0], item[1]); } };
  queued.forEach(function (item) { define(item[0], item[1]); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bind(document); });
  } else {
    bind(document);
  }

  // Theme editor: re-bind a section after it is re-rendered.
  document.addEventListener('shopify:section:load', function (event) { bind(event.target); });
})();
